const defaultDataset = {
    "init": {
        answers: [
            {content: "プログラミングに関してオススメサイトを知りたい", nextId: "recommended_site"},
            {content: "アプリやツールを作ってほしい", nextId: "webapp"},
            {content: "曲に関して", nextId: "music_contact"}
        ],
        question: "こんにちは！ご用件はなんでしょうか？",
    },
    "recommended_site": {
        answers: [
            {content: "無料学習サイト", nextId: "free_website"},
            {content: "有料学習サイト", nextId: "paid_website"},
            {content: "最初の質問に戻る", nextId: "init"}
        ],
        question: "どのようなサイトでしょうか？",
    },
    "free_website": {
        answers: [
            {content: "無料学習サイトへ飛ぶ(ドットインストール)", nextId: "https://dotinstall.com/"},
            {content: "無料学習サイトへ飛ぶ(paiza)", nextId: "https://paiza.jp/works"},
            {content: "最初の質問に戻る", nextId: "init"}
        ],
        question: "無料学習サイト一覧です。",
    },
    "paid_website": {
        answers: [
            {content: "有料学習サイトへ飛ぶ(techpit)", nextId: "https://www.techpit.jp/"},
            {content: "有料学習サイトへ飛ぶ(udemy)", nextId: "https://www.udemy.com/"},
            {content: "最初の質問に戻る", nextId: "init"}
        ],
        question: "有料学習サイト一覧です。",
    },
    "music_contact": {
        answers: [
            {content: "作成を依頼したい", nextId: "request_music"},
            {content: "作成曲を聞きたい", nextId: "check_music"},
            {content: "編集の方法を知りたい", nextId: "edit_music"},
            {content: "最初の質問に戻る", nextId: "init"}
        ],
        question: "曲に関してどのようなご用件でしょうか？",
    },
    "request_music": {
        answers: [
            {content: "問い合わせる", nextId: "contact"},
            {content: "最初の質問に戻る", nextId: "init"}
        ],
        question: "依頼情報をご連絡お願いします。",
    },
    "check_music": {
        answers: [
            {content: "作成曲を確認する", nextId: "https://soundcloud.com/user543681238"},
            {content: "最初の質問に戻る", nextId: "init"}
        ],
        question: "私が作成した曲になります。",
    },
    "edit_music": {
        answers: [
            {content: "問い合わせる", nextId: "contact"},
            {content: "最初の質問に戻る", nextId: "init"}
        ],
        question: "編集に関してわからない事を送信お願いします。",
    },
    "webapp": {
        answers: [
            {content: "問い合わせる", nextId: "contact"},
            {content: "最初の質問に戻る", nextId: "init"}
        ],
        question: "Webアプリ開発についてですね。コチラからお問い合わせできます。",
    },
}

export default defaultDataset